import React from "react";
import { showPopupModal } from "@widgets/CommonModal";
import type { ExcelUpload_S02_Params } from "@menu/XTC/SN_SAL_SAO_REG_001_TEX/excel-upload-tex/types"; // Excek 공통 타입
import ExcelUpload_S02_ReviewSave from "./ExcelUpload_S02_ReviewSave"; // S02 본체 컴포넌트

/** Excel Upload S02(프리뷰/저장) 다이얼로그 오프너 */
export function openS02(args: ExcelUpload_S02_Params) {
  return showPopupModal({
    title: "엑셀 업로드 : 프리뷰/저장",
    children: <ExcelUpload_S02_ReviewSave {...args} />,
    width: "90%",
    height: "90vh",
    okayBtnText: "저장",
    checkData: false,
  });
}
